import { render, staticRenderFns } from "./MediakitProductVariants.vue?vue&type=template&id=3bf436b1&scoped=true&"
import script from "./MediakitProductVariants.vue?vue&type=script&lang=js&"
export * from "./MediakitProductVariants.vue?vue&type=script&lang=js&"
import style0 from "./MediakitProductVariants.vue?vue&type=style&index=0&id=3bf436b1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf436b1",
  null
  
)

export default component.exports